<ng-progress></ng-progress>

<dah-stzh-header/>

<main data-modal="main" class="main">
  <div class="dah-container">
    <div class="layout_wrapper">
    @if (signedIn) {
      <div class="mod_topnav">
        <ul>
          <li routerLink="" routerLinkActive="var_active" [routerLinkActiveOptions]="{ exact: true }">
            <a>Meine Ausschreibungen</a>
          </li>
          @if (id != '-1') {
            <li [routerLink]="['/ausschreibung', id]"
              routerLinkActive="var_active"
              [routerLinkActiveOptions]="{ exact: true }">
              <a>{{selectedAusschreibungTitle}}</a>
            </li>
          }
          @if (angebot) {
            <li [routerLink]="['/angebot/', id]"
              routerLinkActive="var_active"
              [routerLinkActiveOptions]="{ exact: true }">
              <a>Ihr Angebot</a>
            </li>
          }
        </ul>
      </div>
    }
    <div class="layout_section">
      @if (pageTitle | async; as title) {
        <h1 class="dah-heading" id="anchorContent">{{title}}</h1>
      }
      <router-outlet></router-outlet>
    </div>
    </div>
  </div>
</main>

@if (isLanding) {
  <footer class="dah-footer">
    <div class="dah-container dah-footer__inner">
      <div class="dah-footer__copyright">© {{year}} {{tenant.content.copyright}}</div>
      <div class="dah-footer__info">
        <div class="dah-footer__links">
          @for (link of tenant.content.footer.helpLinks; track link.path) {
            <a [href]="addBaseUrl(link.path)">{{link.label}}</a>
          }
        </div>
        <address class="dah-footer__address">
          @for (line of tenant.content.footer.addressLines; track $index) {{{line}}@if (!$last) {<br />}}
        </address>
      </div>
      <div class="dah-footer__legal">
        @for (link of tenant.content.footer.legalLinks; track link.path) {
          <a [href]="addBaseUrl(link.path)">{{link.label}}</a>
        }
      </div>
    </div>
  </footer>
} @else {
  <footer class="dah-footer dah-footer--egov">
    <div class="dah-container dah-footer__inner">
      <div class="dah-footer__copyright">© {{year}} {{tenant.content.copyright}}</div>
      <a class="dah-footer__info-link" [href]="addBaseUrl(tenant.content.footer.helpLinks[0].path)" target="_blank">{{tenant.content.footer.helpLinks[0].label}}</a>
      <div class="dah-footer__legal">
        @for (link of tenant.content.footer.legalLinks; track link.path) {
          <a [href]="addBaseUrl(link.path)" target="_blank">{{link.label}}</a>
        }
      </div>
    </div>
  </footer>
}
